function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("title", null, "asset_per_mappa-12");

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "ASSET"
}, /*#__PURE__*/React.createElement("path", {
  d: "M47.41,44.89,36.18,33.67a15.59,15.59,0,1,0-3.25,2.93L44.31,48ZM13,23.64A11.25,11.25,0,1,1,24.22,34.89,11.25,11.25,0,0,1,13,23.64Z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M28.76,31.24,28,30s3.88-2.48,3.79-6.86a8.08,8.08,0,0,0-5.28-7.26L27,14.52a9.55,9.55,0,0,1,6.23,8.59C33.34,28.3,29,31.12,28.76,31.24Z"
}));

var SvgIcoSearch = function SvgIcoSearch(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 56 56",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIcoSearch, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/ico_search.34efcdaa.svg";
export { ForwardRef as ReactComponent };